import { DatePicker, Select } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link } from "react-router-dom";
import { get_auditory_checkpos } from "../../../../api/endpoints/auditory";
import { get_clients_simplified } from "../../../../api/endpoints/clients";
import {
  openNotificationWithIcon,
  TYPE,
} from "../../../../utils/notificationToast";
import Main from "../../../layout/main/Main";
import { Typo } from "../../../layout/theme";
import { AntdButton, Container, ImageSection, Inner } from "./styles";

const { Option } = Select;

export default function AuditoryCT() {
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  const fetch_clients = async () => {
    const res = await get_clients_simplified("approved");
    setClients(res);
  };

  useEffect(() => {
    fetch_clients();
  }, []);

  const handleSubmit = async () => {
    if (!selectedMonth) {
      openNotificationWithIcon(
        TYPE.ERROR,
        "Falta elegir un mes",
        "Elija un mes para poder descargar."
      );
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        month: moment(selectedMonth).month() + 1,
        year: moment(selectedMonth).year(),
        client: selectedClient || "",
      };
      const res = await get_auditory_checkpos(
        data.month,
        data.year,
        data.client
      );
      const href = URL.createObjectURL(res);

      const link = document.createElement("a");
      link.href = href;

      const fileName =
        "Auditory_" +
        "Month_" +
        (data.month + 1) +
        "_Year_" +
        data.year +
        "_" +
        moment().format("DDMMYYYYhhmmss") +
        ".xlsx";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadYear = async () => {
    if (!selectedYear) {
      openNotificationWithIcon(
        TYPE.ERROR,
        "Falta elegir un año",
        "Elija un año para poder descargar la auditoría anual."
      );
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        month: "",
        year: moment(selectedYear).year(),
        client: selectedClient || "",
      };
      const res = await get_auditory_checkpos(
        data.month,
        data.year,
        data.client
      );
      const href = URL.createObjectURL(res);

      const link = document.createElement("a");
      link.href = href;

      const fileName =
        "Auditory_" +
        "Year_" +
        data.year +
        "_" +
        moment().format("DDMMYYYYhhmmss") +
        ".xlsx";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Main>
      <Main.Header>
        <Main.Breadcrumb>
          <Main.BreadcrumbItem>
            <Link to="/">Home</Link>
          </Main.BreadcrumbItem>
          <Main.BreadcrumbSeparator />
          <Main.ActiveBreadcrumbItem>Auditoria</Main.ActiveBreadcrumbItem>
        </Main.Breadcrumb>
      </Main.Header>
      <Main.Body>
        <Inner>
          <ImageSection>
            <Typo type="primary" level={5}>
              Auditoria
            </Typo>
            <Select
              style={{ width: "200px" }}
              onChange={(e) => setSelectedClient(e)}
              placeholder="Elegir Cliente"
            >
              {clients?.map((i) => (
                <Option value={i.id}>{i.name}</Option>
              ))}
            </Select>
            <Container>
              <DatePicker.MonthPicker
                onChange={(e) => setSelectedMonth(e)}
                placeholder="Seleccionar mes"
                format="MMMM"
              />
              <AntdButton onClick={(e) => handleSubmit(e)} loading={isLoading}>
                <BsDownload
                  style={{ position: "relative", top: "0.8px", left: "-5px" }}
                />{" "}
                Descargar Auditoria Mensual
              </AntdButton>
            </Container>
            <Container>
              <DatePicker.YearPicker
                onChange={(e) => setSelectedYear(e)}
                placeholder="Seleccionar año"
                format="YYYY"
              />
              <AntdButton
                onClick={(e) => handleDownloadYear(e)}
                loading={isLoading}
              >
                <BsDownload
                  style={{ position: "relative", top: "0.8px", left: "-5px" }}
                />{" "}
                Descargar Auditoria Anual
              </AntdButton>
            </Container>
          </ImageSection>
        </Inner>
      </Main.Body>
    </Main>
  );
}
